<template>
  <div class="createNotesForm">
    <form
      class="forms-sample"
      style="border-radius: 10px; border: 1px solid gainsboro"
    >
      <h5 class="createNoteHeading">What's this note about?</h5>
      <!-- body input -->
      <div class="form-group">
        <div class="text_editor">
           <tiny-mce-editor
           :vModelName.sync="support_comment" 
          @onInput="onInput"
          @handleKeydown="handleKeydown"
          ref="textarea" 
          rows="6" 
          placeholder="Add Note here...">
          </tiny-mce-editor>
        </div>
      </div>
      <div class="text-right">
        <button type="button" class="btn addNotes"  @click="save"> <i class="fas fa-plus"></i> Add Note</button>
      </div>
    </form>
  </div>
</template>
<script>
import TinymceEditor from "../../views/partials/tiny_mce_editor";
export default {
  name: "createNotes",
  components: {
    "tiny-mce-editor": TinymceEditor,
  },
  data: function () {
        return {
          support_comment:'',
          renderedContent:'',
          comments: {},
          mini_loading:false,
          users: [],
          filteredUsers: [],  
          showSuggestions: false,
          searchQuery: '',    
          selectedIndex: 0,
          selected_user: [],
          isHighlighted: false,
          top: 0,
          lastTop:44,
         };
      },
        created(){
          let users = this.$store.dispatch('users/assignToUser');
          // let users = this.$store.getters['users/assignToUser'];
          this.users = users.filter(user => user.id  !=  localStorage.getItem('admin_id'));
          // this.filteredUsers = users.filter(user => user.id  !=  localStorage.getItem('admin_id'));
        },
        mounted() {
         
        },
         computed: {
          getSupportComment() {
           
            this.support_comment='';
            this.showSuggestions = false;
          },

        },
        watch:{
          support_comment(newVal, oldVal) {
            this.selected_user.forEach(user => {
              const tag = `@${user.username}`;
              if (!newVal.includes(tag) && oldVal.includes(tag)) {
                this.filteredUsers.push(user);
                this.selected_user = this.selected_user.filter(selected => selected !== user);
              }
            });
          }
        },

      methods: {
        save() {
          let support_comment = this.support_comment;
         
          if(support_comment.trim().length==0)
          {
             this.$toast.error("Note is required");
             return false;
          }

      
          this.mini_loading = true;
          this.$store
            .dispatch("support/saveCommnet", [support_comment, null,this.selected_user,this.$route.params.id])
            .then(() => {
              this.$toast.success("Note added successfully");
              this.support_comment = '';
              this.$store.dispatch('users/getLeadNotes', ["lead_id",this.$route.params.id]);
              this.$emit("updateNoteTabValue", true);
            })
            .catch((error) => {
              this.$toast.error("something went wrong");
              this.support_comment = '';
               this.mini_loading = false;
            });
        },
        onInput(e,l) {

          if (l.key === '@') {
              this.showSuggestions = true;
              this.filteredUsers = this.users
              this.filteredUsers = this.filteredUsers.filter(user => !this.selected_user.includes(user));
          }else{
            // const contentBeforeCursor = e.getContent({ format: 'text' });
            // const atIndex = contentBeforeCursor.lastIndexOf('@');

            // // Check if '@' is present and we're typing after it
            // if (atIndex !== -1) {
            //   // Extract the text after '@'
            //   const textAfterAt = contentBeforeCursor.slice(atIndex + 1);

            //   // Check if the text after '@' equals 'abc'
            //   if (textAfterAt.length>0) {
            //     console.log('The user typed');
            //     // Trigger your desired action when @abc is typed
            //     // this.handleAtAbcDetected();
            //   }
            // }
          // this.showSuggestions = true;


        // console.log('editor content', editor.getContent());
          
          // const cursorPosition = e.target.selectionStart;
          
          //  
        //   const textarea = this.$refs.textarea;

        //   const lines = textarea.value.substr(0, cursorPosition).split('\n');
        //   const lineNumber = lines.length;
        //  if(lineNumber<5 && lineNumber>1)
        //  {
        //   const lineHeight = 40; 
        //   this.top = lineNumber * lineHeight;
        //  }else if(lineNumber == 1){
        //    this.top = cursorPosition;
        //  }

        //    if(this.top>170){
        //     this.lastTop = 170;
        //    }else{
        //     this.lastTop = 44;
        //    }
          // const textBeforeCursor = this.support_comment.slice(0, cursorPosition);
          const contentBeforeCursor = e.getContent({ format: 'text' });
          const atIndex = contentBeforeCursor.lastIndexOf('@');

          if (atIndex !== -1) {
            const substringAfterAt = contentBeforeCursor.slice(atIndex + 1);
            if(/^[^\s]*$/.test(substringAfterAt)) {
              this.searchQuery = substringAfterAt;
          
            if (this.searchQuery.length > 0) {
              this.filteredUsers = this.users.filter(user =>
                user.username.toLowerCase().includes(this.searchQuery.toLowerCase())
              );

              this.filteredUsers = this.filteredUsers.filter(user => !this.selected_user.includes(user));
              
              this.showSuggestions = this.filteredUsers.length > 0;
            }else{
              this.filteredUsers = this.filteredUsers.filter(user => !this.selected_user.includes(user));

            }
          } 
        } 
          }

          },  
      selectUser(user, editor) {
            const atIndex = this.support_comment.lastIndexOf('@');

            this.support_comment = this.support_comment.slice(0, atIndex) + `<span style='line-height: 30px;color: white;background: #48a6a6;padding: 4px;border-radius: 6px;font-size: 14px;'>@${user.username}</span> &nbsp;`;

            this.showSuggestions = false;
            this.searchQuery = ''; 

            if (!this.selected_user.includes(user)) {
            this.selected_user.push(user);
            }

            editor.setContent(this.support_comment);

            setTimeout(() => {
            // Get the editor selection
            const range = editor.selection.getRng();
            const newNode = editor.getBody().lastChild;

            range.setStartAfter(newNode);
            range.setEndAfter(newNode);

            editor.selection.setRng(range);

            editor.focus();
            }, 0);
      }, 
      handleKeydown(editor,e) {
      const itemCount = 5;
    
      if (e.keyCode === 32) { 
          console.log('space');
          this.showSuggestions = false;
      }

    if (this.showSuggestions) {
        if (e.key === 'ArrowDown') {
          // alert('down');
            e.preventDefault();
            this.selectedIndex = (this.selectedIndex + 1) % this.filteredUsers.length;
            this.isHighlighted = true;
            this.scrollToSelected();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.selectedIndex = (this.selectedIndex - 1 + this.filteredUsers.length) % this.filteredUsers.length;
            this.scrollToSelected();
        } else if (e.key === 'Enter') {
            e.preventDefault();
            this.showSuggestions = false;
            this.selectUser(this.filteredUsers[this.selectedIndex], editor);
            
        }
    }
},

      scrollToSelected() {
          this.$nextTick(() => {
              const container = this.$el.querySelector('.suggestions-container');
              const selectedItem = container.querySelector('.active');
                console.log('scroll')
              if (container && selectedItem) {
                  const containerTop = container.scrollTop;
                  const containerHeight = container.clientHeight;
                  const itemTop = selectedItem.offsetTop;
                  const itemHeight = selectedItem.clientHeight;
                  
                  // Adjust scroll position if needed
                  if (itemTop < containerTop) {
                      container.scrollTop = itemTop;
                  } else if (itemTop + itemHeight > containerTop + containerHeight) {
                      container.scrollTop = itemTop + itemHeight - containerHeight;
                  }
              }
          });
      }
      ,
          close(){
            this.support_comment = ''; // Reset the editor's content variable
            this.showSuggestions = false;
          }
      },
};
</script>